import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ScaffoldFooter from '@itt/frontend-scaffold-components/dist/Footer/Footer';
import { getFooterData } from '../../../../store/footer/actions';

const Footer = ({ ...rest }) => {
  const dispatch = useDispatch();
  const { navs, platform } = useSelector(state => state.footer);

  useEffect(() => {
    dispatch(getFooterData());
  }, [dispatch]);
  return <ScaffoldFooter navs={navs} platform={platform} {...rest} />;
};

export default Footer;
